import React from 'react';
import ReactDOM from 'react-dom/client';
import './utils/fetchInterceptor';
import './index.css';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import { AlertProvider } from './components/CustomAlert/AlertContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AlertProvider>
        <App />
      </AlertProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
